// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"TopImage_imageWrapper__2SjDI"};